import React, { Component } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { Editor } from '@tinymce/tinymce-react';

/**
 * Component for html field
 * @author   Milan Stanojevic
 *
 * TinyMCE is loaded locally from /public/tinymce (self-hosted).
 * No apiKey, no cdn.tiny.cloud, no limits.
 */
class HtmlImage extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(val) {
        const { multilang, lang, value, onChange } = this.props;

        if (multilang) {
            onChange({
                ...(value || {}),
                [lang]: val,
            });
        } else {
            onChange(val);
        }
    }

    getValue() {
        const { multilang, lang, value } = this.props;

        if (multilang) {
            return (value && value[lang]) ? value[lang] : '';
        }

        return value || '';
    }

    render() {
        const { label, disabled, height } = this.props;

        return (
            <FormGroup>
                {label ? <Label>{label}</Label> : null}

                <Editor
                    tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                    disabled={disabled}
                    value={this.getValue()}
                    onEditorChange={this.handleChange}
                    init={{
                        plugins: 'link table code image lists',
                        toolbar: 'undo redo | blocks | bold italic underline | ' +
                            'alignleft aligncenter alignright | bullist numlist | ' +
                            'link image table | code',
                        menubar: false,
                        branding: false,
                        height: height ? height : 500,
                        content_css: '/content.css',
                    }}
                />
            </FormGroup>
        );
    }
}

export default HtmlImage;